import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { ToastProvider } from 'react-toast-notifications'
import { MyCustomToastContainer } from '@miscs/custom-toast'
import { Provider } from 'react-redux'
import { store } from './redux/store'

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#69131C',
        },
        secondary: {
            main: '#AAA',
        },
    },
    mixins: {
        toolbar: {
            // eslint-disable-next-line no-useless-computed-key
            ['@media (min-width:0px) and (orientation: landscape)']: {
                minHeight: '50px',
            },
            // eslint-disable-next-line no-useless-computed-key
            ['@media (min-width:600px)']: { minHeight: '50px' },
            minHeight: '50px',
        },
    },
    overrides: {
        MuiDialogTitle: {
            root: {
                backgroundColor: '#69131C',
                padding: '10px 24px',
                '& h2': {
                    color: '#FFF',
                },
            },
        },
        MuiDialogContent: {
            root: {
                padding: '18px 24px',
            },
        },
    },
})
// 機器升級測試
// avoid hook without both of function or class component
window.__react_toast_provider = React.createRef()

ReactDOM.render(
    // suspense for i18 tool
    <React.Suspense fallback="loading">
        <Provider store={store}>
            <MuiThemeProvider theme={theme}>
                <ToastProvider components={{ ToastContainer: MyCustomToastContainer }} ref={window.__react_toast_provider}>
                    <App />
                </ToastProvider>
            </MuiThemeProvider>
        </Provider>
    </React.Suspense>,
    document.getElementById('root')
)
